<div (click)="open($event)" class="icon-toggle">
  <wchfs-icon-dp [svgIcon]="'wchfs:calendar'"></wchfs-icon-dp>
</div>
